import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { publicApi } from "../admin/api";

/**
 * Fires a pageview event to /api/analytics/pageview on every route change.
 * Best-effort: errors are silenced to avoid impacting UX.
 */
export default function PageviewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const path = pathname + (search || "");
    const payload = {
      path,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
    };
    // fire & forget
    publicApi.post("/analytics/pageview", payload).catch(() => {});
  }, [pathname, search]);

  return null;
}
